import {
    SET_ORDER,
    GET_MANAGED_EQUIPMENT_ITEM_DETAILS,
    SET_MANAGED_EQUIPMENT_ITEM_DETAILS,
    SHOW_CATALOG_ITEM_DETAILS
} from './types';

 const getManagedEquipmentItemDetails = (catalogRequestBody:{}, fleetRequestDetailId?: number | null) => {
    return {
      type: GET_MANAGED_EQUIPMENT_ITEM_DETAILS,
      catalogRequestBody,
      fleetRequestDetailId
    }
  }
  
 const setManagedEquipmentItemDetails = (catalogDetails:any,noRecordsMessage:string, fleetRequestDetailId?: number | null) => {
    return {
      type: SET_MANAGED_EQUIPMENT_ITEM_DETAILS,
      catalogDetails,noRecordsMessage, fleetRequestDetailId
    }
  }
  
const setOrderDetails = (orderDetails:any) => {
    return {
        type: SET_ORDER,
        orderDetails
    }
}
export const showCatalogItemDetails=(val:boolean)=>{
  return{
    type:SHOW_CATALOG_ITEM_DETAILS,
    payload:val
  }
}
export {
    setOrderDetails,
    getManagedEquipmentItemDetails,
    setManagedEquipmentItemDetails
}